import React from 'react';
import { get } from 'lodash-es';
import { getModelState } from 'client/data/luckdragon/model';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { DealershipsModel, buildDealershipsPath, buildNationalDealershipsPath } from 'client/data/models/dealerships';
import { VehicleModel } from 'client/data/models/vehicle';
import { getQuery } from 'client/utils/location';
import { getDealershipsLandingTitle } from 'client/site-modules/dealerships/utils/seo-utils';

import { DealershipsLanding } from './dealerships-landing';

const getPropsFromLocation = location => {
  const { make, pagenumber: pageNum = 1 } = getQuery(location);
  return { make, pageNum };
};

export const pageDefinitionConfiguration = {
  name: 'localdealers_make_index',
  category: 'dealerships',
  preload: (store, props) => {
    const { make, pageNum } = getPropsFromLocation(props.location);

    const preloader = new ModelPreloader(store);

    preloader.resolve(
      make ? buildDealershipsPath({ make, pageNum }) : buildNationalDealershipsPath({ pageNum }),
      DealershipsModel
    );
    preloader.resolve('makes', VehicleModel);

    return preloader.load();
  },
  seo: (state, props) => {
    const { make, pageNum } = getPropsFromLocation(props.location);
    const modelState = getModelState(state);
    const makes = modelState.get('makes', VehicleModel);
    const dealershipsSearchResults = modelState.get(
      make ? buildDealershipsPath({ make, pageNum }) : buildNationalDealershipsPath({ pageNum }),
      DealershipsModel
    );
    const totalNumber = get(dealershipsSearchResults, 'totalNumber');
    const makeName = get(makes, `${make}.name`);

    const title = getDealershipsLandingTitle({
      totalNumber: makeName ? totalNumber : undefined,
      makeName,
      useSimpleTitle: true,
    });

    return {
      title: `${title} | Edmunds`,
      canonical: 'https://www.edmunds.com/dealerships/',
      description:
        'Search Edmunds.com for local car dealers by state or make with our comprehensive car dealership directory.',
    };
  },
  component: props => <DealershipsLanding {...props} {...getPropsFromLocation(props.location)} />,
};

export default pageDefinition(pageDefinitionConfiguration);
